import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Button from "components/shared/Button/Button";
import { GlobalContext } from "context/Provider";
import session from "helpers/session";
import API from "api";

export default function GlobalThresholds() {
    const { config, configDispatch } = useContext(GlobalContext);
    const [thresholdData, setThresholdData] = useState({})
    const handleSubmit = () => {
        const thresholdUpdateBody = {
            organization: `${session.crackCookieUserOrg("provider")}`, 
            thresholdsUpdates: {
                defaultThresholds: thresholdData
            }
        }
        API.kore.configurations.updateOrgConfigThresholds(thresholdUpdateBody)
    };

    // TODO: refactor this useEffect to use the default threshold that is set on the thresholds route.
    // useEffect(() => {
    //     if(!config?.organizationOptions.length){
    //         API.kore.configurations.getConfigurations().then((conf) => {
    //             configDispatch({ type: "OPTIONS_UPLOAD", payload: conf });
    //         });
    //     }else{
    //         // @ts-ignore
    //         const defaultThresholds = config?.organizationOptions[0].find((res)=>res.organization === `${session.crackCookieUserOrg("provider")}`)?.defaultThresholds
    //         setThresholdData(defaultThresholds)
    //     }
        
    // }, [config]);
  return (
    <div
      style={{
        width: "98%",
        height: "96%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        paddingLeft: "1%"
      }}
    >
      <Box>
        <h1>Global Thresholds</h1>
      </Box>
      <Button variant="success" type="submit" width="100%" onClick={handleSubmit} disabled={false}>
        Submit
      </Button>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }}>
          <StyledTableHead>
            <TableRow>
              <TableCell align={"center"} colSpan={1}>
                Reading Type
              </TableCell>
              <TableCell align={"left"} colSpan={1}>
                Lower Than
              </TableCell>
              <TableCell align={"left"} colSpan={1}>
                Higher Than
              </TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {Object.entries(thresholdData).map((readingType: any) => {
              return (
                <ThresholdRow
                  readingType={readingType[0]}
                  initialValue={readingType[1]}
                  setThresholdData={setThresholdData}
                  thresholdData={thresholdData}
                />
            );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
export const StyledTableHead = styled(TableHead)`
  .MuiTableCell-head {
    font-weight: bold;
  }
`;

export const StyledTableRow = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: #f5f5f5;
  }
`;
const ThresholdRow = (props: any) => {
  const { readingType, initialValue, setThresholdData, thresholdData } = props;
  const [readingValue, setReadingValue] = useState(initialValue);
  const handleValueChange = (value: any, name: any) => {
    setReadingValue({ ...readingValue, [readingType]:{[name]: value }});
    setThresholdData({...thresholdData, [readingType]:{...thresholdData[readingType] , [name]: parseFloat(value) }})
    return setReadingValue({ ...readingValue, [name]: value });
  };
  return (
    <StyledTableRow>
      <TableCell>
        <div
          style={{
            display: "flex",
            justifyContent: "center"
          }}
        >
          {`${readingType.split(/(?=[A-Z])/)[0][0].toUpperCase()}${readingType.split(/(?=[A-Z])/).join(" ").slice(1)}`}
        </div>
      </TableCell>
      <TableCell>
        <TextField
          id="filled-number"
          label="threshold > value"
          type="number"
          variant="filled"
          size="small"
          value={readingValue.low}
          onChange={(e: any) => handleValueChange(e.target.value, "low")}
          inputProps={{
            style: { textAlign: "center" }
          }}
        />
      </TableCell>
      <TableCell>
        <TextField
          id="filled-number"
          label="threshold < value"
          type="number"
          variant="filled"
          size="small"
          value={readingValue.high}
          onChange={(e: any) => handleValueChange(e.target.value, "high")}
          inputProps={{
            style: { textAlign: "center" }
          }}
        />
      </TableCell>
    </StyledTableRow>
  );
};